

export function isInteger(value){
    let isInt = Number.isInteger(Number(value))
    return isInt
} 

//alias !isNaN()
export function isNumber(value){
    let isNum = Number(value)
    return  Boolean(isNum)
}

export function isNegativeNumber(value){
    let isNum = Number(value)
    return  Boolean(isNum) && isNum<0
}


export function checkPassword(password, passwordPolicy){
    
    //console.log('checkPassword passwordPolicy')
    //console.log(passwordPolicy)

    if (!passwordPolicy.Enabled) return true;

    password = password ? password : ''


    let upperFound = false;
    let lowerFound = false;
    //debugger
    for (var i=0; i<password.length; i++){
        let s = password[i];

        let isDigit = s.match( /\d/g );
        let isNotAlphaNumeric = s.match( /\W/g );

        if(isDigit || isNotAlphaNumeric || s==='_') continue

        if (s.toUpperCase() === s) upperFound = true;

        if (s.toLowerCase() === s) lowerFound = true;

    }

    if (passwordPolicy.UpperCharacters && !upperFound) return false;
    
    if (passwordPolicy.LowerCharacters && !lowerFound)  return false;
            

    if (passwordPolicy.DigitCharacters > 0){
        let n = password.match( /\d/g );
        n = n ? n = n.length : 0;
        if (n < passwordPolicy.DigitCharacters) return false;
    }

    if (passwordPolicy.NonAlphaNumericCharacters > 0){
        let n = password.match( /\W/g );
        n = n ? n = n.length : 0;
        if (n < passwordPolicy.NonAlphaNumericCharacters) return false;
    }


    if (password.length < passwordPolicy.TotalCharacters) return false;

    return true;
}